import { del, EndPoints, get, patch, post } from '../';
export function list() {
    return get(EndPoints.hygienes, { all: 1 });
}
export function createHygiene(request) {
    return post(EndPoints.hygienesCreate, request);
}
export function updateHygiene(request) {
    return patch(EndPoints.hygienesUpdate, request);
}
export function deleteHygiene(request) {
    return del(EndPoints.hygienesDelete, request);
}
